import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Spinner, Alert, Card } from 'react-bootstrap';
import { DoctorsIcon, ServicesH2, ServicesP} from "../components/services/ServicesElements";
import { BASE_URL } from '../constants';
const DoctorDetailScreen = () => {
  const { id } = useParams();
  const [doctor, setDoctor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDoctor = async () => {
      try {
        const response = await fetch(`${BASE_URL}/doctors/${id}`);
        if (!response.ok) {
          throw new Error('Failed to fetch doctor details');
        }
        const data = await response.json();
        setDoctor(data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchDoctor();
  }, [id]);

  if (loading) return <Spinner animation="border" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <Container className="mt-5">
      <Card>
        <DoctorsIcon variant="top" src={doctor.profilePhoto} alt={`${doctor.name}'s profile`}/>
        <Card.Body>
          <Card.Title>{doctor.name}</Card.Title>
          <Card.Text>Specialty: {doctor.specialty}</Card.Text>
          <Card.Text>Email: {doctor.email}</Card.Text>
          <Card.Text>Phone: {doctor.phone}</Card.Text>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default DoctorDetailScreen;
